export interface PlanogramSummaryItem {
  trackedState: string | number | null;
  count: number;
  name?: string;
}

export interface StatusField {
  name: string;
  value: string;
}

export interface FilterFields {
  status?: {
    fieldName: string;
    fieldValues: StatusField[];
  };
}

/**
 * Interface representing the payload structure for planogram API requests.
 */
export interface PlanogramPayload {
  from: string;
  to: string;
  zoneId?: string;
  siteId?: string | null;
  category: string;
  worktableZoneIds: string[];
  trackedState?: string[];
  entityIds?: string[];
  hierarchyId: string;
}

/**
 * Interface representing a Planogram Entity response.
 */
export interface PlanogramEntity {
  uniqueId: string;
  type: number;
  category: string;
  deviceName: string;
  available: boolean;
  entityId: string;
  entityName: string;
  mappingId: string;
  coordinates: Coordinates;
  trackedState: number;
  tags?: string[];
  sourceTimestamp: string; // ISO 8601 Date String
  _id: string;
  workTableZone: { _id: string; name: string }[];
}

/**
 * Interface for the coordinates object.
 */
export interface Coordinates {
  x: number | null;
  y: number | null;
}

/**
 * Interface representing a Planogram TIS response item.
 */
export interface PlanogramTis {
  entityId: string;
  TIS: string; // ISO 8601 Date String
}

export interface ColorMappingItem {
  name: string;
  value: string;
  bgTrackState?: string;
  summaryTrackState?: string;
  historyState?: string;
}

// Add the interface for timelapse data
export interface TimelapseData {
  entityId: string;
  timelapse: {
    value: string;
    trackedState: string;
  }[];
}

/**
 * Interface representing a single timelapse data item for a planogram entity
 */
export interface PlanogramTimelapseItem {
  entityId: string;
  timelapse: TimelapseSegment[];
}

/**
 * Interface representing a segment of time spent in a particular tracked state
 */
export interface TimelapseSegment {
  value: string;
  trackedState: string;
}
